// home page tab section
$(document).ready(function() {
  setTimeout(function() {
    $('.tab-content .tab-pane .product-item .img-product img').each(function() {
        var width = $(this).width(); 
        $(this).height(width);
    });
 }, 200);
$('[data-toggle="tab"]').on('click', function() {
  setTimeout(function() {
    $('.tab-content .tab-pane .product-item .img-product img').each(function() {
        var width = $(this).width(); 
        $(this).height(width);
    });
    }, 200);
  });
  
});


// collaction load more
$(document).ready(function() {
  setTimeout(function() {
    $('.collection_prod .product-grid-view .grid-uniform .trans-product .product-item .img-product img').each(function() {
        var width = $(this).width(); 
        $(this).height(width);
    });
 }, 200);

var targetNode = $('.grid-uniform')[0]; 
if (targetNode instanceof Node) {
    var config = { childList: true };
    var callback = function(mutationsList, observer) {
        for(var mutation of mutationsList) {
            if (mutation.type === 'childList') {
            setTimeout(function() {
              $('.collection_prod .product-grid-view .grid-uniform .trans-product .product-item .img-product img').each(function() {
                  var width = $(this).width(); 
                  $(this).height(width);
              });
             }, 200);
            }
        }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
} else {
    console.error('Invalid target node.');
}
  
});

// related products
$(document).ready(function() {
  setTimeout(function() {
    $('.product-item .img-product img').each(function() {
        var width = $(this).width(); 
        $(this).height(width);
    });
 }, 200);
  
});



